<template>
  <v-app>
    <v-main class="background-color">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSession from "vue-session";
import Vuetify from "vuetify";
import DrawCanvas from "vue-draw-canvas";
import ICS from "vue-ics";

Vue.use(ICS);
Vue.use(DrawCanvas);
Vue.use(Vuetify);
Vue.use(VueAxios, axios);
Vue.use(VueSession, { persist: true });

export default {
  name: "App",
  components: {},
};
</script>
<style>
.background-home {
  background-color: #e3ebef !important;
}
</style>
